<template>
    <div class="wrapper">
        <div class="app-header-wrap">
            <app-header :is-fixed="true"></app-header>
        </div>
        <div class="download">
            <header>
                <ul class="header-tabs flex-row">
                    <li v-for="(items,index) in tabs" :key="index" :class="items.liClassName" @click="tabsClick(index)">
                        <div :class="index === tabsIndex ? items.selectClassName : items.defaultClassName"></div>
                        <p :class="index === tabsIndex ? 'color-blue': ''">{{ items.text }}</p>
                    </li>
                </ul>
                <!-- <div class="header-tabs-border" :style="{transform:'translateX(' + 190 * tabsIndex + 'px)'}"></div> -->
            </header>
            <div class="tab-main">
                <transition name="slide" mode="out-in">
                    <div class="main-box flex-row" v-if="0 === tabsIndex" key="pc">
                        <img class="tab-main-image" src="../../../assets/images/download/download_img_pc.png" alt="">
                        <div class="pc-main-option">
                            <!-- <div class="pc-download"> -->
                                <div class="flex-row">
                                    <div class="flex-row" style="flex: 1;">
                                        <img class="app-logo" src="../../../assets/images/download/download_logo.png" alt="">
                                        <div>
                                            <p class="hfsfd-teacher-pc-head">好分数辅导-PC端</p>
                                            <p class="hfsfd-teacher-pc-middle">好分数旗下1对1在线辅导品牌</p>
                                            <p class="hfsfd-teacher-pc-foot">支持系统：Windows7/8/10</p>
                                        </div>
                                    </div>
                                    <a href="https://ayx-oss-public.aiyunxiao.com/client_packages/mobile_app/product/users/huangyanpeng/2021-08-06/fudao1v1_2.3.0.1-%E6%AD%A3%E5%BC%8F%E7%89%88.exe"
                                    class="btn" target="_self" title="window安装包下载">立即下载</a>
                                </div>
                                <p class="pulgins-text">插件下载</p>
                                <!-- <div class="pulgins-box flex-row">
                                    <div class="flex-row">
                                        <img class="app-logo" src="../../../assets/images/download/download_icon.png" alt="">
                                        <div>
                                            <p class="net-framework-head">.net framework 4.0</p>
                                            <p class="net-framework-foot">支持系统：Windows xp</p>
                                        </div>
                                    </div>
                                    <a href="https://download.microsoft.com/download/1/B/E/1BE39E79-7E39-46A3-96FF-047F95396215/dotNetFx40_Full_setup.exe"
                                    class="btn" target="_self" title="window安装包下载">立即下载</a>
                                </div> -->
                                <div class="pulgins-box flex-row">
                                    <div class="flex-row">
                                        <img class="app-logo" src="../../../assets/images/download/download_icon.png" alt="">
                                        <div>
                                            <p class="net-framework-head">.net framework 4.5</p>
                                            <p class="net-framework-foot">支持系统：Windows 7/8/10</p>
                                        </div>
                                    </div>
                                    <a href="https://ayx-oss-public.aiyunxiao.com/client_packages/mobile_app/product/users/huangyanpeng/2021-08-06/dotNetFx45_Full_setup.exe"
                                    class="btn" target="_self" title="window安装包下载">立即下载</a>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="main-box flex-row" v-if="1 === tabsIndex" key="pad">
                        <img class="tab-main-image" src="../../../assets/images/download/download_img_pad.png" alt="">
                        <div class="pad-main">
                            <div class="pad-main-head flex-row">
                                <img class="app-logo" src="../../../assets/images/download/download_logo_pad.png" alt="">
                                <div>
                                    <p class="hfsfd-teacher-pc-head">好分数辅导-Pad端</p>
                                    <p class="hfsfd-teacher-pc-middle">好分数旗下1对1在线辅导品牌</p>
                                </div>
                            </div>
                            <div class="pad-erweima flex-row">
                                <img class="erweima-img" src="../../../assets/images/download/download.png" alt="">
                                <div>
                                    <div class="padapp-btn" :class="{'mousedown-css': anzuoPress}"
                                    @mousedown="mouseClickDown('android')" @mouseup="mouseClickUp('android')">
                                        <a href="https://appvm.yunxiao.com/dl/5962e98db9375ceb9920ed44" target="_self" class="padapp-btn-android">Android版下载</a>
                                    </div>
                                    <div class="padapp-btn" :class="{'mousedown-css': iosPress}"
                                    @mousedown="mouseClickDown('ios')" @mouseup="mouseClickUp('ios')">
                                        <a href="https://itunes.apple.com/cn/app/id495115809" target="_blank"
                                           class="padapp-btn-ios">iOS版下载</a>
                                    </div>
                                </div>
                            </div>
                            <p class="pad-foot-text">用手机扫上方二维码，或选择合适的手机系统下载</p>
                        </div>
                    </div>
                    <div class="main-box flex-row" v-if="2 === tabsIndex" key="mobile">
                        <img class="tab-main-image" src="../../../assets/images/download/download_img_app1.png" alt="">
                        <div class="pad-main">
                            <div class="pad-main-head flex-row">
                                <img class="app-logo" src="../../../assets/images/download/download_logo_app.png" alt="">
                                <div>
                                    <p class="hfsfd-teacher-pc-head">好分数辅导-手机端</p>
                                    <p class="hfsfd-teacher-pc-middle">好分数旗下1对1在线辅导品牌</p>
                                </div>
                            </div>
                            <div class="pad-erweima flex-row">
                                <img class="erweima-img" src="../../../assets/images/download/download.png"
                                    alt="">
                                <div>
                                    <div class="padapp-btn" :class="{'mousedown-css': anzuoPress}"
                                    @mousedown="mouseClickDown('android')" @mouseup="mouseClickUp('android')">
                                        <a href="https://appvm.yunxiao.com/dl/5962e92fb9375ceb9920ed43" target="_self" class="padapp-btn-android">Android版下载</a>
                                    </div>
                                    <div class="padapp-btn" :class="{'mousedown-css': iosPress}"
                                    @mousedown="mouseClickDown('ios')" @mouseup="mouseClickUp('ios')">
                                        <a href="https://itunes.apple.com/cn/app/id512892359" target="_blank"
                                           class="padapp-btn-ios">iOS版下载</a>
                                    </div>
                                </div>
                            </div>
                            <p class="pad-foot-text">用手机扫上方二维码，或选择合适的手机系统下载</p>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <app-footer :simple="false"></app-footer>
    </div>
</template>

<script>
import AppHeader from './AppHomeHeader';
import AppFooter from './AppFooter';

export default {
    components: { AppHeader, AppFooter },
    data() {
        return {
            tabs: [
                {
                    liClassName: 'header-tab-pc',
                    text: '电脑',
                    defaultClassName: 'header-tab-pc-default',
                    selectClassName: 'header-tab-pc-selected'
                },
                {
                    liClassName: 'header-tab-ipad',
                    text: '平板',
                    defaultClassName: 'header-tab-ipad-default',
                    selectClassName: 'header-tab-ipad-selected'
                },
                {
                    liClassName: 'header-tab-mobile',
                    text: '手机',
                    defaultClassName: 'header-tab-mobile-default',
                    selectClassName: 'header-tab-mobile-selected'
                }
            ],
            tabsIndex: 0,
            anzuoPress: false,
            iosPress: false
        };
    },
    methods: {
        tabsClick(idx) {
            this.tabsIndex = idx;
        },
        mouseClickDown(val) {
            if (val === 'android') {
                this.anzuoPress = true;
                return;
            }
            this.iosPress = true;
        },
        mouseClickUp(val) {
            if (val === 'android') {
                this.anzuoPress = false;
                return;
            }
            this.iosPress = false;
        }
    },
    beforeMount() {
        this.tabsIndex = +this.$route.query.device || 0;
    }
};
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
}

.wrapper {
    min-height: 100vh;
    width: 100%;
    background-color: #fff;
}
.app-header-wrap {
    height: 70px;
    margin-bottom: 20px;
}

.download {
    width: 1300px;
    margin: 0 auto;
    overflow: hidden;

    header {
        position: relative;
        padding-bottom: 2px;
    }

    .header-tabs {
        justify-content: center;
        font-size: 16px;
        color: #bfb2b0;

        li {
            width: 50px;
            margin: 0 70px;
            line-height: 24px;
            text-align: center;
            cursor: pointer;

            &:hover {
                color: #54423d;
            }

            div {
                width: 36px;
                height: 36px;
                margin: 0 auto;
                background: {
                    position: center;
                    repeat: no-repeat;
                    size: cover;
                }
            }
        }

        .color-blue {
            color: #54423d;
        }

        .header-tab-pc-default {
            background-image: url('../../../assets/images/download/download_icon_pc_default.png');
        }

        .header-tab-mobile-default {
            background-image: url('../../../assets/images/download/download_icon_phone_default.png');
        }

        .header-tab-ipad-default {
            background-image: url('../../../assets/images/download/download_icon_pad_default.png');
        }

        .header-tab-pc-selected {
            background-image: url('../../../assets/images/download/download_icon_pac_selected.png');
        }

        .header-tab-mobile-selected {
            background-image: url('../../../assets/images/download/download_icon_phone_selected.png');
        }

        .header-tab-ipad-selected {
            background-image: url('../../../assets/images/download/download_icon_pad_selected.png');
        }

        .header-tab-pc:hover div {
            background-image: url('../../../assets/images/download/download_icon_pac_selected.png');
        }

        .header-tab-mobile:hover div {
            background-image: url('../../../assets/images/download/download_icon_phone_selected.png');
        }

        .header-tab-ipad:hover div {
            background-image: url('../../../assets/images/download/download_icon_pad_selected.png');
        }
    }

    .header-tabs-border {
        width: 50px;
        height: 2px;
        background-color: #1daef8;
        position: absolute;
        bottom: 0;
        left: 435px;
        transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    .tab-main {
        width: 100%;
        padding: 60px 0;
        line-height: 1.375;
    }

    .main-box {
        justify-content: center;
    }

    .tab-main-image {
        width: 600px;
        height: 600px;
    }

    .pc-main-option {
        display: flex;
        width: 600px;
        flex-direction: column;
        justify-content: center;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .pc-main-option > div,
    .pulgins-box > div,
    .pad-main-head {
        align-items: center;
    }

    .pulgins-box {
        justify-content: space-between;
    }

    .app-logo {
        width: 120px;
        height: 120px;
        margin-right: 15px;
    }

    .hfsfd-teacher-pc-head {
        font-size: 32px;
        color: #666;
    }

    .hfsfd-teacher-pc-middle {
        margin: 8px 0;
        font-size: 22px;
        color: #999;
    }

    .hfsfd-teacher-pc-foot {
        font-size: 18px;
        color: #999;
    }

    .pulgins-text {
        margin: 20px 0 10px;
        padding-left: 20px;
        font-size: 18px;
        color: #333;
    }

    .btn {
        width: 110px;
        height: 40px;
        line-height: 38px;
        margin-left: 30px;
        border: 1px solid #f4664b;
        border-radius: 30px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #f4664b;
        text-align: center;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            color: #fff;
            background-color: #f4664b;
            border: 1px solid #f4664b;
        }
    }

    .net-framework-head {
        font-size: 18px;
        color: #333;
        margin-bottom: 25px;
    }

    .net-framework-foot {
        font-size: 14px;
        color: #999;
    }

    .pad-main {
        display: flex;
        width: 600px;
        flex-direction: column;
        justify-content: center;
    }

    .erweima-img {
        width: 140px;
        height: 140px;
    }

    .pad-erweima {
        margin: 40px 0 26px 20px;
    }

    .pad-foot-text {
        padding-left: 20px;
        font-size: 18px;
        color: #999;
    }

    .padapp-btn {
        width: 240px;
        height: 56px;
        line-height: 54px;
        border: 1px solid #f4664b;
        border-radius: 30px;
        margin-left: 30px;
        padding-left: 44px;
        font-size: 18px;
        color: #f4664b;
        cursor: pointer;

        &:hover {
            background-color: #f4664b;
            border: 1px solid #f4664b;

            a {
                color: #fff;
            }

            .padapp-btn-android {
                background: {
                    image: url('../../../assets/images/download/download_img_anzhuo_pressed.png');
                    size: 20px 25px;
                }
            }

            .padapp-btn-ios {
                background: {
                    image: url('../../../assets/images/download/download_img_ios_pressed.png');
                    size: 20px 24px;
                }
            }
        }

        &:first-child {
            margin-bottom: 24px;
        }

        a {
            display: inline-block;
            text-decoration: none;
            color: #f4664b;
            padding-left: 33px;
            background: {
                repeat: no-repeat;
                position: left center;
            }
        }

        .padapp-btn-android {
            background: {
                image: url('../../../assets/images/download/download_img_anzhuo.png');
                size: 20px 25px;
            }
        }

        .padapp-btn-ios {
            background: {
                image: url('../../../assets/images/download/download_img_ios.png');
                size: 20px 24px;
            }
        }
    }

    .slide-enter-active,
    .slide-leave-active {
        transition: all 0.3s;
    }

    .slide-enter,
    .slide-leave-to {
        opacity: 0;
    }

    .mousedown-css {
        background-color: #f4664b;
        color: white;

        .padapp-btn-android {
            background: {
                image: url('../../../assets/images/download/download_img_anzhuo_pressed.png');
                size: 20px 25px;
            }
        }

        .padapp-btn-ios {
            background: {
                image: url('../../../assets/images/download/download_img_ios_pressed.png');
                size: 20px 24px;
            }
        }
    }

    .pc-download {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/DownLoad.vue